module.exports = __webpack_public_path__ + "static/media/shia-3.db8c5832.mp3";